import { Meta } from "@/shared/components";
import { Documents } from "@/admin/features/documents";

/**
 * Страница управления документами
 */
export function DocumentsPage() {
  return (
    <>
      <Meta title="Документы" />
      <Documents />
    </>
  );
}
